// La page où revenir après la connexion (CDC GBM du 27/10, SE-3) : « Se reconnecter » et les routes
// réservées passent la page courante dans `/login?retour=…`. Seul un chemin de ce site est suivi :
// jamais une autre origine (le paramètre se fabrique dans un lien).

export function retourSur(valeur: string | null | undefined): string | null {
  if (!valeur || !valeur.startsWith('/') || valeur.startsWith('//') || valeur.includes('\\')) return null
  if (/[\u0000-\u001f\u007f]/.test(valeur)) return null       // tabulation ou retour : « /\t/x » vaut « //x »
  if (/^\/login(?:[/?#]|$)/.test(valeur)) return null
  return valeur
}

/** La page de connexion, qui ramènera à `page`. */
export function lienReconnexion(page: string): string {
  return retourSur(page) ? `/login?retour=${encodeURIComponent(page)}` : '/login'
}
